<template>
  <div class="reportFeedback">
    <div class="line"></div>
    <div class="feedback-content">
      <span class="feedback-leftDesc">以上报告内容对你有帮助吗？</span>
      <span class="feedback-rightSec" @click.stop="onFeedback">
        <img
          class="feedback-rightSec-icon"
          :src="
            setPicSize(
              'https://pic1.zhuanstatic.com/zhuanzh/8337d01d-9c55-4423-96f5-64ad15f0696d.png'
            )
          "
        />
        <span class="feedback-rightSec-desc">我要反馈</span>
      </span>
    </div>
  </div>
</template>
<script>
  import native from '@zz-common/native-adapter'
  import { setPicSize } from '@zz-common/zz-utils'

  export default {
    components: {},
    props: {
      dataInfo: {
        type: Object,
        default: () => {},
      },
      infoId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        setPicSize,
      }
    },
    methods: {
      onFeedback() {
        console.log(123123, 'sdf')
        const infoId = this.infoId
        const { cateFirstId, title, infoLv, handPriceVo } = this.dataInfo
        const _extend = {
          pageName: '鉴定报告',
          pgCateId: cateFirstId,
          infoId,
          infoName: title,
          quality: infoLv?.level || '',
          price: (handPriceVo?.handPriceCent || 0) / 100,
        }

        const targetUrl = `https://m.zhuanzhuan.com/common/uem/index.html?questionnaireId=1680911179762896896&extend=${encodeURIComponent(
          encodeURIComponent(JSON.stringify(_extend))
        )}&needHideHead=3&wvCornerRadius=32&wvHalfVer=v2&wvHeightRate=0.8#/question-bch`
        native.skipToUrl({
          targetUrl,
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
  .reportFeedback {
    margin: 16px 0 0;
    position: relative;
    z-index: 4;
    .line {
      position: relative;
      width: 598px;
      height: 1px;
      margin: 0 auto;
      &::after {
        @include hairline(#f0f0f0);
        border-bottom-width: 1px;
      }
    }
    .feedback-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 598px;
      margin: 30px auto;
      line-height: 1;
      .feedback-leftDesc {
        color: #111111;
        font-weight: 300;
        font-size: 22px;
        font-family: PingFangSC-Light, PingFang SC;
      }
      .feedback-rightSec {
        display: flex;
        align-items: center;
        .feedback-rightSec-icon {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          object-fit: cover;
        }
        .feedback-rightSec-desc {
          color: #111;
          font-weight: 300;
          font-size: 22px;
          font-family: PingFangSC-Light, PingFang SC;
        }
      }
    }
  }
</style>
